export const buildChatUrl = (type, email) => {
    switch (type) {
        case "teams":
            return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
        default:
            return `mailto:${email}`;
    }
};
